import type { IEsito} from "@/app/Comms";
import {Comms} from "@/app/Comms";
import {Model} from "@/app/Model";
import {Utils} from "@/app/Utils";
import {ItemPenale, ItemReatoRubrica} from "@/app/data/PenaleAdmin";

export class PenaleAdminComms {

    public comms: Comms | undefined = undefined;
    protected static instance: PenaleAdminComms;
    protected constructor() {
        //keep it protected to help with the singleton instance
    }

    public inChiamataPenaleList: boolean = false;
    public inChiamataPenaleSave: boolean = false;
    public inChiamataReatoRubricaList: boolean = false;
    public inChiamataReatoRubricaSave: boolean = false;
    public inChiamataReatoRubricaAdd: boolean = false;
    public inChiamataReatoRubricaDel: boolean = false;

    public inChiamataMassiveDelete: boolean = false;
    public inChiamataMassiveReplace: boolean = false;
    public inChiamataCapo_imputazione_legge: boolean = false;


    public static getInstance(): PenaleAdminComms {
        if (!PenaleAdminComms.instance) {
            PenaleAdminComms.instance = new PenaleAdminComms();
        }
        return PenaleAdminComms.instance;
    }

    public chiamataPenaleList(callback: Function | null = null, soloPaginazione:boolean = false): void {
        if (this.comms) {
            if (Comms.hf_isNotLogged()) {
                if (this.comms.continueFunction) this.comms.continueFunction = this.chiamataPenaleList;
                setTimeout(function () {
                    Comms.getInstance().doLoginByToken(callback);
                }, Comms.baseLoadTimeout);
                return;
            } else {
                this.comms.continueFunction = null;
            }
            let model: Model = Model.getReactiveInstance();
            if (!this.inChiamataPenaleList) {
                this.inChiamataPenaleList = true;
                model.pen_admin.listaPenale = [];
                let commander: string = "chiamataPenaleList";
                let endpoint: string = "/graphql";
                let filters: string = '';
                let someFilters: string = '';
                //---
                //filtri  da model.pen_admin.filtriPenale
                if (model.pen_admin.filtriPenale.capo_imputazione_legge != "") someFilters += ` { field: "capo_imputazione_legge", condition: "contains", value: "${model.pen_admin.filtriPenale.capo_imputazione_legge}" }
                    `;
                if (model.pen_admin.filtriPenale.id_doc_master != "") someFilters += ` { field: "id_doc_master", condition: "=", value: "${model.pen_admin.filtriPenale.id_doc_master}" }
                    `;
                if (model.pen_admin.filtriPenale.assoluzione != "") someFilters += ` { field: "assoluzione", condition: "like", value: "${model.pen_admin.filtriPenale.assoluzione}" }
                    `;
                if (Number(model.pen_admin.filtriPenale.id_stato_sen) === 1) someFilters += ` { field: "id_stato_sen", condition: "=", value: "1" }
                `;
                if (Number(model.pen_admin.filtriPenale.id_stato_sen) > 1) someFilters += ` { field: "id_stato_sen", condition: ">", value: "1" }
                `;
                if (model.pen_admin.filtriPenale.modifica_manuale != "") someFilters += ` { field: "modifica_manuale", condition: "=", value: "${model.pen_admin.filtriPenale.modifica_manuale}" }
                    `;

                //---
                if (someFilters != '') {
                    filters = `where: {
                must: [
                            ${someFilters}
                        ]
                    }`;
                }
                let payload = {
                    query: `{
                    msPenaleQuery(
                        order: [{ field: "${model.pen_admin.filtriPenale.sort_field}", order: ${model.pen_admin.filtriPenale.sort_order} }]
                        ${filters}
                        select: ["*"]
                        paging: {offset:${model.pen_admin.paginazionePenale_start * model.pen_admin.paginazionePenale_rows} , limit:${model.pen_admin.paginazionePenale_rows}}
                      ) {
                            list
                            count
                            raw
                        }
                }`,
                    variables: {},
                    operationName: null,
                };

                let options = {
                    method: "POST",
                    headers: {
                        accept: "application/json",
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                };
                //@ts-ignore
                if (Comms.baseUrl == "") options.headers["x-user"] = model.user.jwt;

                let errorCallback: Function = (): void => {
                    this.inChiamataPenaleList = false;
                };
                let innerCallback: Function = (esito: IEsito): void => {
                    Utils.successAlert(esito);
                    this.inChiamataPenaleList = false;
                    if (esito.response && esito.response.data && esito.response.data.msPenaleQuery && esito.response.data.msPenaleQuery.list) {
                        esito.response.data.msPenaleQuery.list.forEach( (x: any) => model.pen_admin.listaPenale.push(this.prepareItemFromLoad(x, true)));
                        model.pen_admin.paginazionePenale_tot = esito.response.data.msPenaleQuery.count;
                        model.pen_admin.paginazionePenale_pages = Math.ceil(model.pen_admin.paginazionePenale_tot / model.pen_admin.paginazionePenale_rows) -1;
                        if (model.pen_admin.paginazionePenale_start > model.pen_admin.paginazionePenale_pages) model.pen_admin.paginazionePenale_start = model.pen_admin.paginazionePenale_pages;

                        if (!soloPaginazione) {
                            model.pen_admin.paginazionePenale_start = 0;
                        }
                    }
                    if (callback) callback(esito);
                };
                this.comms.doFetch(endpoint, options, commander, innerCallback, errorCallback);
            }
        }
    }
    public chiamataPenaleSave(callback: Function | null = null): void {
        let model: Model = Model.getReactiveInstance();

        if (this.comms &&  model.pen_admin.itemPenale.id_doc_master != undefined && model.pen_admin.itemPenale.id_doc_master > 0) {
            if (Comms.hf_isNotLogged()) {
                if (this.comms.continueFunction) this.comms.continueFunction = this.chiamataPenaleSave;
                setTimeout(function () {
                    Comms.getInstance().doLoginByToken(callback);
                }, Comms.baseLoadTimeout);
                return;
            } else {
                this.comms.continueFunction = null;
            }

            if (!this.inChiamataPenaleSave) {
                this.inChiamataPenaleSave = true;
                let commander: string = "chiamataPenaleSave";
                let endpoint: string = "/graphql";
                let itemToSend : any = this.prepareItemForSave(model.pen_admin.itemPenale);
                let payload = {
                    query: `mutation {
  msPenaleUpdate(
    input: ${JSON.stringify(itemToSend).replace(/"([^"]+)":/g, "$1:")}
  )
}
`,
                    variables: {},
                    operationName: null,
                };

                let options = {
                    method: "POST",
                    headers: {
                        accept: "application/json",
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                };
                //@ts-ignore
                if (Comms.baseUrl == "") options.headers["x-user"] = model.user.jwt;

                let errorCallback: Function = (): void => {
                    this.inChiamataPenaleSave = false;
                };
                let innerCallback: Function = (esito: IEsito): void => {
                    Utils.successAlert(esito);
                    this.inChiamataPenaleSave = false;
                    if (esito.response && esito.response.data && esito.response.data.msPenaleUpdate) {
                        model.pen_admin.itemPenale = this.prepareItemFromLoad(esito.response.data.msPenaleUpdate,true);
                    }
                    Comms.getInstance().penaleAdmin.chiamataPenaleList((e: IEsito) => { }, false);
                    if (callback) callback(esito);
                };
                this.comms.doFetch(endpoint, options, commander, innerCallback, errorCallback);
            }
        }
    }

    public chiamataReatoRubricaList(callback: Function | null = null, soloPaginazione:boolean = false): void {
        if (this.comms) {
            if (Comms.hf_isNotLogged()) {
                if (this.comms.continueFunction) this.comms.continueFunction = this.chiamataReatoRubricaList;
                setTimeout(function () {
                    Comms.getInstance().doLoginByToken(callback);
                }, Comms.baseLoadTimeout);
                return;
            } else {
                this.comms.continueFunction = null;
            }
            let model: Model = Model.getReactiveInstance();
            if (!this.inChiamataReatoRubricaList) {
                this.inChiamataReatoRubricaList = true;
                model.pen_admin.listaReatoRubrica = [];
                let commander: string = "chiamataReatoRubricaList";
                let endpoint: string = "/graphql";
                let filters: string = '';
                let someFilters: string = '';
                //---

                //filtri  da model.pen_admin.filtriReatoRubrica
                if (model.pen_admin.filtriReatoRubrica.capo_imputazione_str != "") someFilters += ` { field: "capo_imputazione_str", condition: "like", value: "${model.pen_admin.filtriReatoRubrica.capo_imputazione_str}" }
                `;
                if (model.pen_admin.filtriReatoRubrica.tip_atto != "") someFilters += ` { field: "tip_atto", condition: "=", value: "${model.pen_admin.filtriReatoRubrica.tip_atto.toUpperCase()}" }
                `;
                if (model.pen_admin.filtriReatoRubrica.rubrica != "") someFilters += ` { field: "rubrica", condition: "like", value: "${model.pen_admin.filtriReatoRubrica.rubrica}" }
                `;
                
                //---
                if (someFilters != '') {
                    filters = `where: {
                must: [
                            ${someFilters}
                        ]
                    }`;
                }
                let payload = {
                    query: `{
                    msReatoRubricaQuery(
                        order: [{ field: "${model.pen_admin.filtriReatoRubrica.sort_field}", order: ${model.pen_admin.filtriReatoRubrica.sort_order} }]
                        ${filters}
                        select: ["*"]
                        paging: {offset:${model.pen_admin.paginazioneReatoRubrica_start * model.pen_admin.paginazioneReatoRubrica_rows} , limit:${model.pen_admin.paginazioneReatoRubrica_rows}}
                      ) {
                            list
                            count
                            raw
                        }
                }`,
                    variables: {},
                    operationName: null,
                };

                let options = {
                    method: "POST",
                    headers: {
                        accept: "application/json",
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                };
                //@ts-ignore
                if (Comms.baseUrl == "") options.headers["x-user"] = model.user.jwt;

                let errorCallback: Function = (): void => {
                    this.inChiamataReatoRubricaList = false;
                };
                let innerCallback: Function = (esito: IEsito): void => {
                    Utils.successAlert(esito);
                    this.inChiamataReatoRubricaList = false;
                    if (esito.response && esito.response.data && esito.response.data.msReatoRubricaQuery && esito.response.data.msReatoRubricaQuery.list) {
                        esito.response.data.msReatoRubricaQuery.list.forEach( (x: any) => model.pen_admin.listaReatoRubrica.push(this.prepareItemFromLoad(x, false)));
                        model.pen_admin.paginazioneReatoRubrica_tot = esito.response.data.msReatoRubricaQuery.count;
                        model.pen_admin.paginazioneReatoRubrica_pages = Math.ceil(model.pen_admin.paginazioneReatoRubrica_tot / model.pen_admin.paginazionePenale_rows) -1;
                        if (model.pen_admin.paginazioneReatoRubrica_start > model.pen_admin.paginazioneReatoRubrica_pages) model.pen_admin.paginazioneReatoRubrica_start = model.pen_admin.paginazioneReatoRubrica_pages;

                        if (!soloPaginazione) {
                            model.pen_admin.paginazioneReatoRubrica_start = 0;
                        }
                    }
                    if (callback) callback(esito);
                };
                this.comms.doFetch(endpoint, options, commander, innerCallback, errorCallback);
            }
        }
    }
    public chiamataReatoRubricaSave(callback: Function | null = null): void {
        if (this.comms) {
            if (Comms.hf_isNotLogged()) {
                if (this.comms.continueFunction) this.comms.continueFunction = this.chiamataReatoRubricaSave;
                setTimeout(function () {
                    Comms.getInstance().doLoginByToken(callback);
                }, Comms.baseLoadTimeout);
                return;
            } else {
                this.comms.continueFunction = null;
            }
            let model: Model = Model.getReactiveInstance();
            if (!this.inChiamataReatoRubricaSave) {
                this.inChiamataReatoRubricaSave = true;
                let commander: string = "chiamataReatoRubricaSave";
                let endpoint: string = "/graphql";
                let itemToSend : any = this.prepareItemForSave(model.pen_admin.itemReatoRubrica);
                let oldItemToSend : any = model.pen_admin.itemReatoRubrica.raw;
                let payload = {
                    query: `mutation {
  msReatoRubricaUpdate(
    input: ${JSON.stringify(itemToSend).replace(/"([^"]+)":/g, "$1:")}
  )
}
`,
                    variables: {},
                    operationName: null,
                };
//oldReatoRubrica: ${JSON.stringify(oldItemToSend).replace(/"([^"]+)":/g, "$1:")}
                let options = {
                    method: "POST",
                    headers: {
                        accept: "application/json",
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                };
                //@ts-ignore
                if (Comms.baseUrl == "") options.headers["x-user"] = model.user.jwt;

                let errorCallback: Function = (): void => {
                    this.inChiamataReatoRubricaSave = false;
                };
                let innerCallback: Function = (esito: IEsito): void => {
                    Utils.successAlert(esito);
                    this.inChiamataReatoRubricaSave = false;
                    let someError: boolean = false;
                    let errorMessage: string = "";
                    if (esito.response && esito.response.errors && esito.response.errors.length > 0) {
                        someError = true;
                        errorMessage = esito.response.errors[0].message;
                    }
                    if (someError) {
                        alert(errorMessage);
                    } else {
                        if (esito.response && esito.response.data && esito.response.data.msReatoRubricaUpdate) {
                            model.pen_admin.itemReatoRubrica = this.prepareItemFromLoad(esito.response.data.msReatoRubricaUpdate,false);
                        }
                        Comms.getInstance().penaleAdmin.chiamataReatoRubricaList((e: IEsito) => {
                            //@ts-ignore
                            if (window.updateComponentsAdminReatoRubrica) window.updateComponentsAdminReatoRubrica();
                        }, false);
                    }
                    if (callback) callback(esito);
                };
                this.comms.doFetch(endpoint, options, commander, innerCallback, errorCallback);
            }
        }
    }
    public chiamataReatoRubricaAdd(callback: Function | null = null): void {
        let model: Model = Model.getReactiveInstance();
        if (this.comms && model.pen_admin.itemReatoRubrica.capo_imputazione_str != undefined && model.pen_admin.itemReatoRubrica.capo_imputazione_str != "") {
            if (Comms.hf_isNotLogged()) {
                if (this.comms.continueFunction) this.comms.continueFunction = this.chiamataReatoRubricaAdd;
                setTimeout(function () {
                    Comms.getInstance().doLoginByToken(callback);
                }, Comms.baseLoadTimeout);
                return;
            } else {
                this.comms.continueFunction = null;
            }
            if (!this.inChiamataReatoRubricaAdd) {
                this.inChiamataReatoRubricaAdd = true;
                let commander: string = "chiamataReatoRubricaAdd";
                let endpoint: string = "/graphql";
                let itemToSend : any = this.prepareItemForSave(model.pen_admin.itemReatoRubrica);
                let payload = {
                    query: `mutation {
  msReatoRubricaAdd(
    input: ${JSON.stringify(itemToSend).replace(/"([^"]+)":/g, "$1:")}
  )
}
`,
                    variables: {},
                    operationName: null,
                };

                let options = {
                    method: "POST",
                    headers: {
                        accept: "application/json",
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                };
                //@ts-ignore
                if (Comms.baseUrl == "") options.headers["x-user"] = model.user.jwt;

                let errorCallback: Function = (): void => {
                    this.inChiamataReatoRubricaAdd = false;
                };
                let innerCallback: Function = (esito: IEsito): void => {
                    Utils.successAlert(esito);
                    this.inChiamataReatoRubricaAdd = false;
                    let someError: boolean = false;
                    let errorMessage: string = "";
                    if (esito.response && esito.response.errors && esito.response.errors.length > 0) {
                        someError = true;
                        errorMessage = esito.response.errors[0].message;
                    }
                    if (someError) {
                        alert(errorMessage);
                    } else {
                        if (esito.response && esito.response.data && esito.response.data.msReatoRubricaAdd && esito.response.data.msReatoRubricaAdd !== null) {
                            model.pen_admin.itemReatoRubrica = this.prepareItemFromLoad(esito.response.data.msReatoRubricaAdd,false);
                        }
                        Comms.getInstance().penaleAdmin.chiamataReatoRubricaList((e: IEsito) => {
                            //@ts-ignore
                            if (window.updateComponentsAdminReatoRubrica) window.updateComponentsAdminReatoRubrica();
                        }, false);
                    }
                    if (callback) callback(esito);
                };
                this.comms.doFetch(endpoint, options, commander, innerCallback, errorCallback);
            }
        }
        else {
            alert("Inserire il Capo Imputazione")
        }
    }
    public chiamataReatoRubricaDel(callback: Function | null = null): void {
        let model: Model = Model.getReactiveInstance();
        if (this.comms && model.pen_admin.deleteItemReatoRubrica.capo_imputazione_str != "") {
            if (Comms.hf_isNotLogged()) {
                if (this.comms.continueFunction) this.comms.continueFunction = this.chiamataReatoRubricaDel;
                setTimeout(function () {
                    Comms.getInstance().doLoginByToken(callback);
                }, Comms.baseLoadTimeout);
                return;
            } else {
                this.comms.continueFunction = null;
            }
            if (!this.inChiamataReatoRubricaDel) {
                this.inChiamataReatoRubricaDel = true;
                let commander: string = "chiamataReatoRubricaDel";
                let endpoint: string = "/graphql";
                let itemToSend : any = this.prepareItemForSave(model.pen_admin.deleteItemReatoRubrica);
                let payload = {
                    query: `mutation {
  msReatoRubricaRemove(
    input: ${JSON.stringify(itemToSend).replace(/"([^"]+)":/g, "$1:")}
  )
}
`,
                    variables: {},
                    operationName: null,
                };

                let options = {
                    method: "POST",
                    headers: {
                        accept: "application/json",
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                };
                //@ts-ignore
                if (Comms.baseUrl == "") options.headers["x-user"] = model.user.jwt;

                let errorCallback: Function = (): void => {
                    this.inChiamataReatoRubricaDel = false;
                };
                let innerCallback: Function = (esito: IEsito): void => {
                    Utils.successAlert(esito);
                    this.inChiamataReatoRubricaDel = false;
                    if (esito.response && esito.response.data && esito.response.data.msReatoRubricaRemove) {
                        model.pen_admin.deleteItemReatoRubrica = new ItemReatoRubrica();
                    }
                    Comms.getInstance().penaleAdmin.chiamataReatoRubricaList((e: IEsito) => {
                        //@ts-ignore
                        if (window.updateComponentsAdminReatoRubrica) window.updateComponentsAdminReatoRubrica();
                    }, false);
                    if (callback) callback(esito);
                };
                this.comms.doFetch(endpoint, options, commander, innerCallback, errorCallback);
            }
        }
    }

    public prepareItemForSave( item: ItemPenale | ItemReatoRubrica) : any {
        let clone: any = JSON.parse(JSON.stringify(item));
        delete clone.raw;
        return clone;
    }
    public prepareItemFromLoad( item: ItemPenale | ItemReatoRubrica, isPenale: boolean = true) : any {
        if (isPenale) {
            let fieldsArrayToCheck: string[] = [
                "assoluzione_motivo", "capo_imputazione_legge",
                "durata_pena", "giudice", "pena_principale",
                "capo_imputazione_legge_parziale", "capo_imputazione_legge_originale"
            ]
            fieldsArrayToCheck.forEach((field: string): void => {
                //@ts-ignore
                if (item[field] == undefined || item[field] == null) { item[field] = []; }
            });
        }
        let clone: any = JSON.parse(JSON.stringify(item));
        item.raw = clone;
        return item;
    }

    public listCapo_imputazione_legge_rubrica(callback: Function | null = null): void {
        if (this.comms) {
            if (Comms.hf_isNotLogged()) {
                if (this.comms.continueFunction) this.comms.continueFunction = this.listCapo_imputazione_legge_rubrica;
                setTimeout(function () {
                    Comms.getInstance().doLoginByToken(callback);
                }, Comms.baseLoadTimeout);
                return;
            } else {
                this.comms.continueFunction = null;
            }

            let model: Model = Model.getReactiveInstance();
            if (!this.inChiamataCapo_imputazione_legge) {
                this.inChiamataCapo_imputazione_legge = true;
                model.lista_capo_imputazione_legge_rubrica = [];
                let commander: string = "listCapo_imputazione_legge_rubrica";
                let endpoint: string = "/graphql";
                let payload = {
                    query: `{
                    pgQuery(
                         input: {
                            name: "lista_capo_imputazione_legge_rubrica"
                            params: { }
                         }
                    ) {
                         list
                         record
                    }
                }`,
                    variables: {},
                    operationName: null,
                };
                let options = {
                    method: "POST",
                    headers: {
                        accept: "application/json",
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                };
                //@ts-ignore
                if (Comms.baseUrl == "") options.headers["x-user"] = model.user.jwt;

                let errorCallback: Function = (): void => {
                };
                let innerCallback: Function = (esito: IEsito): void => {
                    Utils.successAlert(esito);
                    this.inChiamataCapo_imputazione_legge = false;
                    if (esito.response && esito.response.data && esito.response.data.pgQuery && esito.response.data.pgQuery.list) {
                        model.lista_capo_imputazione_legge_rubrica = esito.response.data.pgQuery.list;
                    }
                    if (callback) callback(esito);
                };
                this.comms.doFetch(endpoint, options, commander, innerCallback, errorCallback);
            }
        }
    }


    public chiamataMassiveReplace(callback: Function | null = null): void {
        let model: Model = Model.getReactiveInstance();
        if (this.comms && model.pen_admin.massiveReplaceCapoImputazione_value != "" && model.pen_admin.massiveReplaceCapoImputazione_to != "") {
            if (Comms.hf_isNotLogged()) {
                if (this.comms.continueFunction) this.comms.continueFunction = this.chiamataMassiveReplace;
                setTimeout(function () {
                    Comms.getInstance().doLoginByToken(callback);
                }, Comms.baseLoadTimeout);
                return;
            } else {
                this.comms.continueFunction = null;
            }
            if (!this.inChiamataMassiveReplace) {
                this.inChiamataMassiveReplace = true;
                let commander: string = "chiamataMassiveReplace";
                let endpoint: string = "/graphql";
                let itemToSend : any = {
                    capo_imputazione_legge: model.pen_admin.massiveReplaceCapoImputazione_value,
                    new_capo_imputazione_legge: model.pen_admin.massiveReplaceCapoImputazione_to
                };
                let payload = {
                    query: `mutation {
  msPenaleMassiveUpdate(
    operazione: "modifica"
    input: ${JSON.stringify(itemToSend).replace(/"([^"]+)":/g, "$1:")}
  )
}
`,
                    variables: {},
                    operationName: null,
                };

                let options = {
                    method: "POST",
                    headers: {
                        accept: "application/json",
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                };
                //@ts-ignore
                if (Comms.baseUrl == "") options.headers["x-user"] = model.user.jwt;

                let errorCallback: Function = (): void => {
                    this.inChiamataMassiveReplace = false;
                };
                let innerCallback: Function = (esito: IEsito): void => {
                    Utils.successAlert(esito);
                    this.inChiamataMassiveReplace = false;
                    if (esito.response && esito.response.data && esito.response.data.msPenaleMassiveUpdate && esito.response.data.msPenaleMassiveUpdate.status && esito.response.data.msPenaleMassiveUpdate.status != "error") {
                    } else {
                        esito.isOk = false;
                    }
                    if (callback) callback(esito);
                };
                this.comms.doFetch(endpoint, options, commander, innerCallback, errorCallback);
            }
        }
    }
    public chiamataMassiveDelete(callback: Function | null = null): void {
        let model: Model = Model.getReactiveInstance();
        if (this.comms && model.pen_admin.massiveDeleteCapoImputazione_value != "") {
            if (Comms.hf_isNotLogged()) {
                if (this.comms.continueFunction) this.comms.continueFunction = this.chiamataMassiveDelete;
                setTimeout(function () {
                    Comms.getInstance().doLoginByToken(callback);
                }, Comms.baseLoadTimeout);
                return;
            } else {
                this.comms.continueFunction = null;
            }
            if (!this.inChiamataMassiveDelete) {
                this.inChiamataMassiveDelete = true;
                let commander: string = "chiamataMassiveDelete";
                let endpoint: string = "/graphql";
                let itemToSend : any = {
                    capo_imputazione_legge: model.pen_admin.massiveDeleteCapoImputazione_value
                };
                let payload = {
                    query: `mutation {
  msPenaleMassiveUpdate(
    operazione: "elimina"
    input: ${JSON.stringify(itemToSend).replace(/"([^"]+)":/g, "$1:")}
  )
}
`,
                    variables: {},
                    operationName: null,
                };

                let options = {
                    method: "POST",
                    headers: {
                        accept: "application/json",
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                };
                //@ts-ignore
                if (Comms.baseUrl == "") options.headers["x-user"] = model.user.jwt;

                let errorCallback: Function = (): void => {
                    this.inChiamataMassiveDelete = false;
                };
                let innerCallback: Function = (esito: IEsito): void => {
                    Utils.successAlert(esito);
                    this.inChiamataMassiveDelete = false;
                    if (esito.response && esito.response.data && esito.response.data.msPenaleMassiveUpdate && esito.response.data.msPenaleMassiveUpdate.status && esito.response.data.msPenaleMassiveUpdate.status != "error") {
                    } else {
                        esito.isOk = false;
                    }
                    if (callback) callback(esito);
                };
                this.comms.doFetch(endpoint, options, commander, innerCallback, errorCallback);
            }
        }
    }
}